import { Inplace } from 'primereact/inplace'
import styled from 'styled-components'

export const PaymentForm = styled.form`
`

export const PaymentFormRow = styled.div`
  margin: 1rem 0;
`

export const LoaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  & > div {
    margin-bottom: 1rem;
  }
`

export const PaymentOptionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  & > button {
    margin-bottom: 1rem;
    margin-right: 0.5rem;
  }
`

export const PaymentInputTextContainer = styled.span`
  height: 2.35rem;
  width: 5rem;

  & .p-inputtext {
    height: 100%;
    width: 100%;
    padding-right: 1.75rem;
    text-align: right;
  }

  & > i {
    height: 100%;
    top: 50%;
    transform: translate(0, -12%);
  }
`

export const PaymentInformationContainer = styled.div`
  margin-bottom: 1rem;
  text-align: center;
`

export const CurrencyInputContainer = styled(Inplace)`
  & .p-inplace-display {
    padding: 0 !important;
    margin: 0;
  }
`
